<template lang="pug">
  md-toolbar.md-transparent(md-elevation='0')
    .md-toolbar-row
      .md-toolbar-section-start
        h3.md-title {{ $route.name }}
      .md-toolbar-section-end
        md-button.md-just-icon.md-simple.md-toolbar-toggle(:class='{ toggled: $sidebar.showSidebar }', @click='toggleSidebar')
          span.icon-bar
          span.icon-bar
          span.icon-bar
        .md-collapse
          md-list
            //- md-list-item.dropdown(href='#/notifications')
            //-   drop-down
            //-     a.dropdown-toggle(slot='title', data-toggle='dropdown')
            //-       i.material-icons notifications
            //-       span.notification 5
            //-       p.hidden-lg.hidden-md Notifications
            //-     ul.dropdown-menu.dropdown-menu-right
            //-       li
            //-         a(href='#') Mike John responded to your email
            //-       li
            //-         a(href='#') You have 5 new tasks
            //-       li
            //-         a(href='#') You're now friend with Andrew
            //-       li
            //-         a(href='#') Another Notification
            //-       li
            //-         a(href='#') Another One
            md-list-item(href='#/user')
              i.material-icons person
              p.hidden-lg.hidden-md Profile

</template>

<script>
export default {
  data() {
    return {
      selectedEmployee: null,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone"
      ]
    };
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  }
};
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/pages/Layout/TopNavbar.vue